module.exports = {
      id: "personalise-usage",
      viewBox: "0 0 14.128 12.555",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#personalise",
      toString: function () {
        return this.url;
      }
    }